import {RentDatesDatepicker} from "./RentDatesDatepicker";
import {OperationSelect} from "./OperationSelect";
import {ApplyOperationType} from "../services/AdFormService";

export interface OperationsInterface {
    validate(): Boolean | undefined
    selectedOperation(): ApplyOperationType | null
    rentStartDate() : null | Date | undefined
    rentEndDate(): null | Date | undefined
}

export class Operations implements OperationsInterface {
    private readonly rentDates: RentDatesDatepicker | null;
    private readonly select: OperationSelect | null;

    constructor(form: HTMLElement | null) {
        this.rentDates = RentDatesDatepicker.init(form);
        this.select = OperationSelect.init(form);

        this.manageDateVisibility();
        this.select?.onChange(() => {
            this.manageDateVisibility();
        });
    }

    public validate() {
        let dontCheckRent = this.select?.isSaleSelected() || this.rentDates == null;
        return dontCheckRent || this.rentDates?.validate()
    }

    public selectedOperation(): ApplyOperationType | null {
        if (this.select == null) {
            return null;
        }
        return this.select.selectedOperation();
    }

    public rentStartDate(): null | Date | undefined {
        if (this.select?.isRentSelected()) {
            return this.rentDates?.getValue()?.start
        }
        return null
    }

    public rentEndDate(): null | Date | undefined {
        if (this.select?.isRentSelected()) {
            return this.rentDates?.getValue()?.end
        }
        return null
    }

    private manageDateVisibility() {
        if (this.select?.isRentSelected()) {
            this.rentDates?.show()
        } else {
            this.rentDates?.hide()
        }
    }
}